import { render, staticRenderFns } from "./UploaderBar.vue?vue&type=template&id=6beac47d"
import script from "./UploaderBar.vue?vue&type=script&lang=js"
export * from "./UploaderBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports